import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};

export const fetchTransaction = createAsyncThunk(
    'masters/fetchTransaction',
    async (query) => {
        try {
            const response = await myAxios.get(`/transactions`);
           
            return { success: true, message: "Transactions fetched successfully!", data: response?.data?.transactions };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);




const transactionSlice = createSlice({
    name: 'transaction',
    initialState,
    reducers: {
        clearTransactionData: state => {
            state.data = [];
        },
        setTransactionData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const transactionReducer = transactionSlice.reducer;
export const { clearTransactionData, setTransactionData } = transactionSlice.actions;

export const selectTransactionData = (state) => state.transaction.data;
